var t = 25569, r = 3600 * 1e3, a = 24 * r;
function n(e) {
  return e.getTime() / a + t;
}
export {
  n as default
};
//# sourceMappingURL=index.es533.js.map
